export const DISPLAY_TYPE_ID = {
  TEXT_URL: 1,
  TEXT_FUNCTION_LINK: 2,
  TEXT_ONLY: 3
};
